import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const AboutStyles = (theme: Theme) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    hero: {
      background: `linear-gradient(180deg, ${accent}1A 0%, transparent 60%)`,
    },
    heroInner: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "40px 16px",
      display: "grid",
      gridTemplateColumns: "1.1fr .9fr",
      gridTemplateAreas: `"text media" "ctas media"`,
      columnGap: 28,
      rowGap: 18,
      alignItems: "start",
    },
    heroText: { gridArea: "text" },
    heroBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "6px 12px",
      borderRadius: 999,
      backgroundColor: `${accent}1A`,
      border: `1px solid ${accent}55`,
      fontWeight: 600,
      fontSize: 12,
      letterSpacing: 0.6,
      textTransform: "uppercase" as const,
    },

    heroCtasBox: { gridArea: "ctas" },
    lead: { fontSize: 16, lineHeight: 1.7, opacity: 0.95 },
    subtitle: { fontSize: 16, lineHeight: 1.7, opacity: 0.92, marginTop: 8 },

    heroCtasRow: {
      display: "flex",
      gap: 12,
      flexWrap: "wrap" as const,
      marginTop: 4,
    },
    heroInnerMobile: {
      gridTemplateColumns: "1fr",
      gridTemplateAreas: `"text" "media" "ctas"`,
    },

    /* --- Buttons --- */
    btnPrimary: {
      textDecoration: "none",
      backgroundColor: accent,
      color: theme.hoverText,
      padding: "10px 16px",
      borderRadius: 12,
      fontWeight: 700,
      border: `1px solid ${accent}`,
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    },
    btnGhost: {
      textDecoration: "none",
      backgroundColor: `${accent}10`,
      color: theme.text,
      padding: "10px 16px",
      borderRadius: 12,
      fontWeight: 700,
      border: `1px solid ${accent}55`,
    },

    heroMedia: { gridArea: "media" },
    bannerBox: {
      width: "100%",
      borderRadius: 16,
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0,0,0,.12)",
      background: `${accent}0F`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    bannerImg: {
      maxWidth: 600,

      display: "block",
    },
    bannerImgMobile: {
      width: "100%",
      height: "auto",
      maxWidth: "none",
    },

    statsStrip: {
      maxWidth: 1140,
      margin: "12px auto 0",
      padding: "12px 16px",

      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
      gap: 10,
    },
    statCard: {
      padding: 12,
      borderRadius: 12,
      background: theme.background,

      textAlign: "center" as const,
    },
    statValue: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      fontSize: 24,
      lineHeight: 1.1,
    },
    statLabel: { fontSize: 12, marginTop: 4, color: theme.status },

    grid3: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 14,
    },
    card: {
      padding: 16,
      borderRadius: 14,
      border: `1px solid ${accent}33`,
      backgroundColor: `${accent}06`,
    },

    /* --- MILESTONES --- */
    timeline: {
      position: "relative" as const,
      paddingInlineStart: 18,
      display: "grid",
      gap: 10,
    },
    timelineItem: {
      display: "grid",
      gridTemplateColumns: "70px 1fr",
      gap: 12,
      alignItems: "start",
    },
    dot: {
      position: "absolute" as const,
      insetInlineStart: 6,
      width: 4,
      height: 4,
      borderRadius: 999,
      background: accent,
      boxShadow: "0 0 0 6px rgba(0,0,0,.04)",
    },
    timelineYear: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      fontSize: 18,
    },
    timelineText: { fontSize: 14, opacity: 0.92 },

    /* --- Team --- */
    grid4: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
      gap: 14,
    },
    personCard: {
      padding: 14,
      borderRadius: 14,
      border: `1px solid ${accent}22`,
      background: theme.card ?? "#fff",
      textAlign: "center" as const,
    },
    avatar: {
      width: 72,
      height: 72,
      margin: "0 auto 10px",
      borderRadius: 999,
      background: `${accent}18`,
      border: `1px solid ${accent}44`,
    },
    personName: { fontWeight: 700 },
    personRole: { fontSize: 13, opacity: 0.8 },

    /* --- CTA --- */
    finalCta: {
      maxWidth: 1140,
      margin: "28px auto 40px",
      padding: "16px",
      borderRadius: 16,
      border: `1px solid ${accent}44`,
      background: `linear-gradient(180deg, ${accent}14 0%, ${accent}06 100%)`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap" as const,
    },
    finalText: { fontWeight: 700, fontSize: 18 },
  } as const;
};
